import { z } from 'zod';

const HOSTNAME_MAX = 253;
const LABEL_RE = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export const createDomainFormSchema = z.object({
  hostname: z
    .string()
    .min(1, 'Hostname is required')
    .max(HOSTNAME_MAX, `Hostname must be ${HOSTNAME_MAX} characters or fewer`)
    .refine(
      (value) => {
        const labels = value.toLowerCase().split('.');
        if (labels.length < 2) return false;
        return labels.every((label) => LABEL_RE.test(label));
      },
      { message: 'Enter a valid hostname (e.g. interviews.acme.com)' }
    ),
});

export type CreateDomainFormValues = z.infer<typeof createDomainFormSchema>;
